import _ from "lodash"

export default {    
    loading: state => state.loading,
    tableIsEmpty: state => state.tableIsEmpty,
    tableData: state => _.cloneDeep(state.tableData),
}